module.exports = __webpack_public_path__ + "static/CI_Logo_4c_2020-8254387fd793a00635992604847a3eca.png";